import React from 'react'
import styled from '@emotion/styled'

import {Icon} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {StyledListItem} from '../commonStyles'

const RowText = styled.span`
  display: inline;
`
interface Props {
  onClick: () => void
}
export const InviteFriendsToGems = ({onClick}: Props) => (
  <StyledListItem
    as="button"
    hasDivider
    onClick={onClick}
    prefix={<Icon name="SpeechBubblePlus" />}
    title={
      <Text variant="labelM">
        <RowText>
          <FormattedMessageWrapper
            id="membership.InviteFriendsToGems"
            defaultMessage="Invite Friends to {gems}"
            values={{
              gems: 'Vio.com'
            }}
          />
        </RowText>
      </Text>
    }
    suffix={<Icon name="ChevronRight" hasMirror />}
  />
)
